<template>
    <div class="cert-summary" :aria-label="$t('student.certificates.title')">
        <article class="cert-summary__card cert-summary__card--accent">
            <span class="cert-summary__icon" aria-hidden="true">
                <v-icon size="20">mdi-certificate-outline</v-icon>
            </span>
            <div>
                <strong>{{ total }}</strong>
                <span>{{ $t('student.certificates.summaryCertificates') }}</span>
            </div>
        </article>
        <article class="cert-summary__card cert-summary__card--done">
            <span class="cert-summary__icon" aria-hidden="true">
                <v-icon size="20">mdi-check-circle-outline</v-icon>
            </span>
            <div>
                <strong>{{ issued }}</strong>
                <span>{{ $t('student.certificates.summaryIssued') }}</span>
            </div>
        </article>
        <article class="cert-summary__card cert-summary__card--pending">
            <span class="cert-summary__icon" aria-hidden="true">
                <v-icon size="20">mdi-clock-outline</v-icon>
            </span>
            <div>
                <strong>{{ pending }}</strong>
                <span>{{ $t('student.certificates.summaryPending') }}</span>
            </div>
        </article>
    </div>
</template>

<script>
    export default {
        name: 'CertificateSummary',
        props: {
            total: { type: Number, required: true },
            issued: { type: Number, required: true },
            pending: { type: Number, required: true },
        },
    };
</script>

<style scoped>
    .cert-summary {
        display: flex;
        flex-wrap: nowrap;
        flex-shrink: 0;
        gap: 10px;
    }

    .cert-summary__card {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 168px;
        flex: 0 0 168px;
        padding: 10px 12px;
        border-radius: 12px;
        background: var(--certs-kpi, #f8fafc);
        border: 1px solid transparent;
    }

    .cert-summary__card strong {
        display: block;
        font-size: 1.25rem;
        line-height: 1;
        color: var(--certs-kpi-text, #111827);
    }

    .cert-summary__card div > span {
        display: block;
        margin-top: 2px;
        font-size: 0.78rem;
        color: var(--certs-kpi-muted, #6b7280);
    }

    .cert-summary__icon {
        width: 36px;
        height: 36px;
        border-radius: 10px;
        display: grid;
        place-items: center;
        flex-shrink: 0;
    }

    @media (max-width: 900px) {
        .cert-summary {
            flex-wrap: wrap;
            width: 100%;
        }

        .cert-summary__card {
            flex: 1 1 150px;
            width: auto;
        }
    }

    .cert-summary__card--accent {
        background: var(--certs-kpi-accent, #f0fbfb);
    }

    .cert-summary__card--accent .cert-summary__icon {
        background: var(--certs-kpi-icon-accent-bg, rgba(26, 196, 205, 0.16));
        color: var(--certs-kpi-icon-accent, #0f766e);
    }

    .cert-summary__card--done {
        background: var(--certs-kpi-done, #f3f1fb);
    }

    .cert-summary__card--done .cert-summary__icon {
        background: var(--certs-kpi-icon-done-bg, rgba(109, 90, 205, 0.14));
        color: var(--certs-kpi-icon-done, #5b4db8);
    }

    .cert-summary__card--pending {
        background: var(--certs-kpi-pending, #fff7ed);
    }

    .cert-summary__card--pending .cert-summary__icon {
        background: var(--certs-kpi-icon-pending-bg, rgba(217, 119, 6, 0.14));
        color: var(--certs-kpi-icon-pending, #b45309);
    }
</style>
